module.exports = __webpack_public_path__ + "static/media/albi.513cfd52.png";


//////////////////
// WEBPACK FOOTER
// ./src/content/devdata/resources/sponsors/albi.png
// module id = 460
// module chunks = 0